module.exports = __webpack_public_path__ + "static/404_cloud_sky.44608217.png";